<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <div class="variant-radio-group">
        <ServiceRadioFormPart @result="onResult" @change="onChange" />
      </div>
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ServiceRadioFormPart from 'chimera/realEstateAgency/components/form/parts/service/ServiceRadioFormPart'
import NextStep from '~/pages/v2/offertes-aanvragen/prijsklasse-woning'

export default {
  name: 'ServiceFormStep',

  components: {
    ServiceRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormShell
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit', this.onSubmit)
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      // PD-10913: hidden market-segment default.
      this.$store.dispatch('lead/add', {
        key: 'market-segment',
        value: this.$t('field.marketSegment.consumer'),
        origin: 'ServiceFormStep',
      })

      this.routeTo(NextStep)
    },
  },
}
</script>
